var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgErrorMsg(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 13,
    height: 12,
    viewBox: "0 0 13 12",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.15479 0C9.45479 0 12.1548 2.7 12.1548 6C12.1548 9.3 9.45479 12 6.15479 12C2.85478 12 0.154785 9.3 0.154785 6C0.154785 2.7 2.85478 0 6.15479 0ZM6.15479 9C6.51478 9 6.75479 8.76 6.75479 8.4C6.75479 8.04 6.51478 7.8 6.15479 7.8C5.79479 7.8 5.55478 8.04 5.55478 8.4C5.55478 8.76 5.79479 9 6.15479 9ZM5.55478 6C5.55478 6.36 5.79479 6.6 6.15479 6.6C6.51478 6.6 6.75479 6.36 6.75479 6V3.6C6.75479 3.24 6.51478 3 6.15479 3C5.79479 3 5.55478 3.24 5.55478 3.6V6Z",
    fill: "#DF1E04"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgErrorMsg);
export default __webpack_public_path__ + "static/media/errorMsg.18dfac9bf5df072fa79351cbebac9ce5.svg";
export { ForwardRef as ReactComponent };